// extracted by mini-css-extract-plugin
export var infoItem = "_qg-2";
export var title = "_qg-0";
export var value = "_qg-1";